/*global eclipseApp, $, _, angular*/
(function () {

  'use strict';

  angular
    .module('eclipseApp.autoRegSetPassword')
    .controller('setAutoRegPasswordCtrl', SetAutoRegPasswordCtrl);

  SetAutoRegPasswordCtrl.$inject = ['$stateParams', 'setPasswordService', 'timerService'];

  function SetAutoRegPasswordCtrl($stateParams, setPasswordService, timerService) {
    var ctrl = this;

    init();

    function init() {
      timerService.stopTimer();
      ctrl.showModule = setPasswordService.showModule;
      setPasswordService.validateToken($stateParams.token);
    }
  }
})();
